export default

    class ProgramsConfigController {

    constructor(resource) {
        this._resource = resource
    }

    getAll(){
        return this._resource('getProgramAll').get()
            .then(res => res.data)
            .catch(error => {
                throw error
            })
    }
    getAllByClient(clientId){
        return this._resource(`getProgramAll/${clientId}`).get()
            .then(res => res.data)
            .catch(error => {
                throw error
            })
    }   

    activeProgram(client_id, users, rateio){
        return this._resource('activeProgram').save({client_id, users, rateio})
            .then(res => res.data)
            .catch(error => {
                throw error
            })
    }
}